import * as React from "react";
import {Col, Container, Row} from "react-bootstrap";
import SidePanel from "./components/SidePanel";
import ConsultationTable from "./components/ConsultationTable";
import QRCode from 'qrcode.react';
import AccessMap from "./components/AccessMap";
import Links from "./components/Links";
import Header from "./components/Header";
import Footer from "./components/Fotter";
import InformationList from "./components/Information";
import SlideShow from "./components/SlideShow";
import IndexPage from "./pages/IndexPage";
import { BrowserRouter as Router, Route , Switch} from "react-router-dom";
import DirectorPage from "./pages/DirectorPage";
import ZionPage from "./pages/Zion";
import CancerPage from "./pages/CancerPage";
import FacilityPage from "./pages/FacilityPage";
import ScopePage from "./pages/ScopePage";
import AccessPage from "./pages/AccessPage";
import InformationPage from "./pages/InformationPage";
import NotfoundPage from "./pages/NotfoundPage";
import LifestylePage from "./pages/LifestylePage";

const App : React.FC<{}> = () => {
    return (
        <React.Fragment>
        {/* @ts-expect-error Async Server Component */}
        <Router>
            <Container className="main"  fluid="md">
                <Header/>
                <main>
                <Row>
                    <Col md={4} className={"side-bar"}>
                        <SidePanel title={"診療時間"} id={"clinic-hours"}>
                            <ConsultationTable/>
                        </SidePanel>
                        <SidePanel title={"モバイルサイト"}>
                            <div className={"qrcode"}>
                                {/* @ts-expect-error Async Server Component */}
                                <QRCode value={location.href}/>
                            </div>
                            <div className={"qrcode-mobile"}>
                                {location.href}
                            </div>
                        </SidePanel>
                        <SidePanel title={"アクセス"}>
                            <AccessMap/>
                        </SidePanel>
                        <SidePanel title={"リンク"} className={"side-links"}>
                            <Links/>
                        </SidePanel>
                    </Col>
                    <Col md={8} className={"main-contents"}>
                        {/* @ts-expect-error Async Server Component */}
                        <Switch>
                            {/* @ts-expect-error Async Server Component */}
                            <Route exact path={"/"} component={IndexPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/index.html"} component={IndexPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/intyou.html"} component={DirectorPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/zion.html"} component={ZionPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/gan.html"} component={CancerPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/setubi.html"} component={FacilityPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/scope.html"} component={ScopePage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/access.html"} component={AccessPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/lifestyle.html"} component={LifestylePage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route path={"/information/:id.html"} component={InformationPage}/>
                            {/* @ts-expect-error Async Server Component */}
                            <Route component={NotfoundPage}/>
                        </Switch>
                    </Col>
                </Row>
                </main>
            </Container>
            <Footer/>
        </Router>
        </React.Fragment>
    );
}

export default App;
